module.exports = __webpack_public_path__ + "static/media/line_grey_16.da0a43e6.svg";